import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Navigation, Autoplay } from 'swiper/modules';
import type { SwiperOptions } from 'swiper/types';
import { readAttribute } from '@helga-agency/ui-tools';

/* global window, HTMLElement */

interface NavigationButtons {
    prevEl: HTMLElement;
    nextEl: HTMLElement;
}

export default class QuoteSlider extends HTMLElement {
    connectedCallback() {
        const sliderElement = this.getSliderElement();
        const autoplayInterval = this.getAttribute('data-quote-slider-interval');

        const swiperParams: SwiperOptions = {
            modules: [Navigation, Autoplay],
            slidesPerView: 1.05,
            grabCursor: true,
            navigation: this.getNavigationButtons(),

            breakpoints: {
                600: {
                    slidesPerView: 1,
                },
            },
        };

        if (autoplayInterval) {
            swiperParams.loop = true;
            swiperParams.autoplay = {
                delay: parseInt(autoplayInterval, 10),
            };
        }

        // eslint-disable-next-line no-new
        new Swiper(sliderElement, swiperParams);
    }

    private getSliderElement(): HTMLElement {
        return readAttribute<HTMLElement>(this, 'data-quote-slider-element-selector', {
            transform: (value) => this.querySelector<HTMLElement>(value),
            validate: (element: HTMLElement | null) => element instanceof HTMLElement,
            expectation: 'a selector that matches the element for data-quote-slider-element-selector',
        });
    }

    private getNavigationButtons(): NavigationButtons {
        const getButton = (
            selector: string,
        ): HTMLElement => readAttribute<HTMLElement>(this, selector, {
            transform: (value) => this.querySelector<HTMLElement>(value),
            validate: (element: HTMLElement) => element instanceof HTMLElement,
            expectation: `a selector that matches the element for ${selector}`,
        });

        return {
            prevEl: getButton('data-quote-slider-prev-button-selector'),
            nextEl: getButton('data-quote-slider-next-button-selector'),
        };
    }

    public static defineElement(): void {
        if (!window.customElements.get('quote-slider')) {
            window.customElements.define('quote-slider', QuoteSlider);
        }
    }
}
